import Route from '@ember/routing/route';

export default class CoachingCoachesRoute extends Route {}
